import { OrderPopover } from '@components/common/OrderPopover';
import { Loading } from '@fourthwall/components';
import { useOrderTimelineEvents } from '@modules/Dashboard/Contributions/modules/Order';
import React from 'react';
export const StatusTagTimeline = ({ orderId }) => {
    const { timelineEvents, isLoading } = useOrderTimelineEvents(orderId);
    return (React.createElement(Loading, { isLoading: isLoading, size: "medium" },
        React.createElement(OrderPopover, { events: isLoading ? undefined : timelineEvents })));
};
